import { PublicPageLoader } from '@/features/public-pages/components/PublicPageLoader';

/**
 * Public Trusted Partners page (`/partners`), fully CMS-driven (MYN-216,
 * MYN-215). Every section renders from the `trusted-partners` page's content
 * via the public read API - no hardcoded copy lives here. Named
 * `TrustedPartnersPublicPage`, not `TrustedPartnersPage` - that name is
 * already taken by the unrelated authenticated in-app Partner Directory +
 * Perks page at `src/pages/trusted-partners/TrustedPartnersPage.tsx` (A-126).
 * The Backend `Page.slug` stays `trusted-partners` (content identifier,
 * independent of this Frontend route's own URL). Loading/not-published/error
 * states are shared across every public page via `PublicPageLoader`.
 */
export function TrustedPartnersPublicPage() {
  return <PublicPageLoader slug="trusted-partners" />;
}
